import { useQuery } from '@tanstack/react-query';
import { getTypeRegime } from '@/services/generic';

export const useTypeRegimes = () => {
  const queryKey = ['type-regimes'];
  return useQuery({
    queryKey,
    queryFn: getTypeRegime,
    select: (data) => ({
      originalData: data,
      select: data.map((item) => ({
        label: item.name,
        value: item.id,
      })),
    }),
  });
};
